import { __ } from '../../../translations';

export const useEpgLocalization = () => {
    const localization = {
        searchLabel: __('search_channel_label'),
        noResultsMsg: __('search_channel_empty_results'),
        favorite_button_label: __('favorite_button_label'),
        remove_favorite_button_label: __('remove_favorite_button_label'),
        live: __('player_lables_Live'),
        before: __('title_prev'),
        after: __('title_next'),
        goLive: __('player_lables_go_live'),
        select_date: __('select_date'),
        choose_category: __('choose_category'),
        date: __('epg_today_label'),
        clearLabel: __('search_clear_text'),
        upgrade_plan_message: __('upgrade_plan_message'),
        freeTier_player_streamConcurrency_errorTitle: __('freeTier_player_streamConcurrency_errorTitle'),
        contentAvailabilityDurationLabel: __('contentAvailabilityDurationLabel'),
        // PPV-related translations
        // ppv_buy_now: __('ppv_buy_now'),
        ppv_buy_now: (placeholder) => __('ppv_buy_now_price', placeholder),
        ppv_for_label: __('ppv_for_label'),
        ppv_currency: __('SAR'),
        ppv_event_label: __('ppv_event_label'),
        ppv_price_label: __('ppv_price_label'),
        ppv_status_label: __('ppv_status_label'),
        ppv_subscribed: __('ppv_subscribed'),
        ppv_not_subscribed: __('ppv_not_subscribed'),
        // PPV availability translations
        ppv_content_available: __('ppv_content_available'),
        ppv_day: __('ppv_day'),
        ppv_days: __('ppv_days'),
        ppv_available_soon: __('ppv_available_soon'),
        live_tv_grace_period_error: __('live_tv_grace_period_error'),
    };
    return localization;
};
